module.exports = "<h1 mat-dialog-title>Confirmación</h1>\r\n<div mat-dialog-content>\r\n  <p>¿ Está seguro de eliminar este registro ?</p>\r\n</div>\r\n<div mat-dialog-actions>\r\n  <button mat-button [mat-dialog-close]=\"'no'\" tabindex=\"2\">No</button>\r\n  <button mat-button [mat-dialog-close]=\"'si'\" tabindex=\"-1\">Si</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/app/main/content/Prefijo/ConfirmarDelete.component.html
// module id = ../../../../../src/app/main/content/Prefijo/ConfirmarDelete.component.html
// module chunks = main